/**
 * @file: 维护工单系统相关接口
 * @author: chenyingliao <chenyingliao@baidu.com>
 * @Date: 2023-02-16 15:25:18
 * @LastEditors: chenyingliao <chenyingliao@baidu.com>
 * @LastEditTime: 2023-10-26 11:51:24
 * @FilePath: /console-znzs/src/api/ticket.js
 */
import Vue from 'vue';
import axios from 'axios';
import Cookies from 'js-cookie';

const ticketServer = axios.create({
    baseURL: '/api/ticket',
    timeout: 60000,
});

const version = {
    v1: 'v1',
    v2: 'v2',
};

ticketServer.interceptors.request.use(config => {
    config.headers.csrftoken = Cookies.get('bce-user-info');
    const monitorPageInfo = window.__MONITOR__PAGE_VIEW_INFO__();
    if (monitorPageInfo) {
        config.headers['X-Bce-Pvid'] = monitorPageInfo?.pageViewId;
        config.headers['X-Bce-Ssid'] = monitorPageInfo?.siteSessionId;
    }
    return config;
});

ticketServer.interceptors.response.use(response => {
    const responseData = response.data;
    if (responseData.state === 'SUCCESS') {
        return responseData;
    }
    else if (responseData.success) {
        return responseData.result;
    }

    Vue.prototype.$notify.warning({
        message: responseData?.message?.global || '抱歉，网络好像出问题了，请重试！',
        duration: 5000,
    });

    return Promise.reject(responseData);
}, err => {
    Vue.prototype.$notify.warning({// 全局配置网络问题响应
        message: '抱歉，网络好像出问题了，请刷新重试！',
        duration: 5000,
    });
    return Promise.reject(err);
});

/**
 * 获取全部产品类型
 * @returns
 */
export const allProductTypes = () => ticketServer.get(`/${version.v1}/category/list`);

/**
 * 获取用户信息
 * @returns
 */
export const ticketUserInfo = () => ticketServer.get(`/${version.v1}/account/user`);

/**
 * 获取推荐产品
 * @returns
 */
export const recommondProduct = () => ticketServer.get(`/${version.v2}/product/recommend`);

/**
 * 上传图片
 * @param {*} data
 * @returns
 */
export const uploadImage = data => ticketServer.post(`/${version.v1}/file/image/upload`, data);

/**
 * 创建工单
 * https://yapi.baidu-int.com/project/23586/interface/api/1868895
 * @param {*} data
 * @returns
 */
export const createTicket = data => ticketServer.post(`/${version.v1}/issue`, data, {
    headers: {
        'x-bce-source': 'ZNZS',
    },
});

/**
 * P3M接口
 * @param {*} serviceName
 * @returns
 */
export const getTypeIdsByServiceName = serviceName =>
    ticketServer.post(`/${version.v1}/category/module`, {module: serviceName.toUpperCase()});

/**
 * 校验主子账号权限，只允许主账号提交工单
 * @returns
 */
export const getPermision = () => ticketServer.post(`/${version.v1}/account/detail`, {});

